import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { postData, fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { faS } from '@fortawesome/free-solid-svg-icons';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';


const AccountHeadCreate = (props) => {
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, token, logout]);

    const [formData, setFormData] = useState({
        CompanyId: companyId,
        Code: '',
        Description: '',
        IsIncome: false,
        createdBy: userId,
        isSubmit: false,
    });

    const [isSubmit, setIsSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const submitData = async (e) => {
        e.preventDefault();

        setIsLoading(true);

        if (!formData.Description || !formData.Code) {
            setErrorMessage("All fields are required!");
            setIsSubmit(false);
            setIsLoading(false);
            return;
        }

        setFormData(prevData => ({
            ...prevData,
            UpdatedBy: userId,
        }));

        postData('AccountHeadApi', formData, token)
            .then((response) => {
                console.log('Account Head Created success:', response);
                setSuccessMessage("Account Head Created successfully!");
                setErrorMessage("");
                history.push('/AccountHeadIndex');
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Account Head Create error:', error);
                setIsLoading(false);
            });
    };

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : (type === 'radio' ? (value === 'true') : value),
        }));
    };


    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto">
                <form onSubmit={submitData}>
                    <div className='w-full mb-2 flex'>
                        <h6 className='uppercase productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>Account Head Create</h6>

                        {/* <Button
                            variant="contained"
                            style={{ marginLeft: '8px', backgroundColor: '#006400', color: 'white' }}
                            onClick={submitData}
                            disabled={isLoading}
                        >
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"}
                        </Button>


                        <Button
                            variant="contained"
                            color="error"
                            component={Link}
                            to="/AccountHeadIndex"
                            className="linkcolor"
                            style={{ marginLeft: '8px' }}
                        >
                            BACK TO LIST
                        </Button> */}

                        <Tooltip title="Exit">
                            <Link to="/AccountHeadIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                                <Button style={{ color: 'red', fontWeight: 'bolder' }}>
                                    EXIT <ExitToAppIcon />
                                </Button>
                            </Link>
                        </Tooltip>

                        <Tooltip title="SAVE">
                            <Button onClick={submitData} style={{ color: 'green', fontWeight: 'bolder' }} disabled={isLoading}>
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"} <CheckCircleIcon />
                            </Button>
                        </Tooltip>

                    </div>


                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}

                    <div className="w-full mb-4 flex">
                        <div className="w-4/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Account Head Name
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.Description}
                                onChange={handleChange}
                                type="text"
                                name="Description"
                                placeholder="Enter Account Head Name"
                            />
                        </div>

                        <div className="w-full sm:w-1/5 pl-2 mb-2 sm:mb-0">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Code
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.Code}
                                onChange={handleChange}
                                type="text"
                                name="Code"
                                placeholder="Enter Code"
                            />
                        </div>
                    </div>

                    <div className="w-full mb-4 flex">
                        <div className="w-full sm:w-1/5 pl-2 mb-2 sm:mb-0">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Income / Expense
                            </label>
                            <div>
                                <label className="inline-flex items-center">
                                    <input
                                        type="radio"
                                        className="form-radio h-4 w-4 text-green-500 border-4 border-gray-400 rounded-full checked:bg-green-500 checked:border-transparent"
                                        name="IsIncome"
                                        value={true}
                                        checked={formData.IsIncome === true}
                                        onChange={handleChange}
                                    />
                                    <span className="ml-2"> <strong>Income</strong></span>
                                </label>
                                <label className="inline-flex items-center ml-6">
                                    <input
                                        type="radio"
                                        className="form-radio h-4 w-4 text-green-500 border-4 border-gray-400 rounded-full checked:bg-green-500 checked:border-transparent"
                                        name="IsIncome"
                                        value={false}
                                        checked={formData.IsIncome === false}
                                        onChange={handleChange}
                                    />
                                    <span className="ml-2"> <strong>Expense</strong></span>
                                </label>
                            </div>
                        </div>

                        {/* <div className="w-full sm:w-1/5 pl-2 mb-2 sm:mb-0">
                            <label className="block text-gray-700 text-base font-bold mb-2">
                                Is Packing Slip Expense?
                            </label>
                            <div className="inline-flex items-center">
                                <input
                                    type="checkbox"
                                    className="form-checkbox h-4 w-4 text-green-500 border-4 border-gray-400 rounded-md checked:bg-green-500 checked:border-transparent"
                                    name="IsPackingSlipExpense"
                                    checked={formData.IsPackingSlipExpense}
                                    onChange={handleChange}
                                />
                                <span className="ml-2">Is Packing Slip Expense</span>
                            </div>
                        </div> */}
                    </div>


                </form>
            </div>
        </Fragment>
    );
};

export default AccountHeadCreate;
